var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"x":"0px","y":"0px","viewBox":"0 0 100 100"}},[_c('gradient-helper'),_c('circle',{attrs:{"cx":"50","cy":"50","r":"47","stroke":_vm.stroke ? 'url(#svg-gradient)' : 'none',"stroke-width":_vm.strokeWidth,"fill":_vm.fill ? 'url(#svg-gradient)' : 'none'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }